module.exports = __webpack_public_path__ + "img/Enoturismo_footer.285ecd26.jpg";